import React from 'react';
import changeProviderProvider from 'mn-utils/changeProviderProvider';
import isEmail from 'mn-utils/isEmail';
import trim from 'mn-utils/trim';
import filter from 'mn-utils/filter';
import {
  apiV2GetTransactionDetails,
  apiV2TransactionRefund,
} from '../../../../api/merchant/transactions';
import {
  openPopupInfo,
} from '../../../../emitters/popup';
const {
  account$
} = require('../../../../emitters/account');
import {
  backLocation,
} from '../../../../router';
import checkingForUpdatesProvider from '../../../../utils/checkingForUpdatesProvider';
import formatNumCurrency from '../../../../utils/formatNumCurrency';
import getIdempotenceKey from '../../../../utils/getIdempotenceKey';
import numberHandle from '../../../../utils/numberHandle';
import withState from '../../../../utils/withState';
import toEllipsisMiddle from '../../../../utils/toEllipsisMiddle';
import ButtonBack from '../../../dumb/Button/BackB';
import Button from '../../../dumb/Button/Accept';
import Caption from '../../../dumb/Caption/B';
import Switch from '../../../dumb/Switch/D';
import TextField from '../../../dumb/TextField/A';
import WrapperWithLoading from '../../../dumb/WrapperWithLoading/B';
import Tooltip from '../../../dumb/Tooltip/B';
import noop from "mn-utils/noop";
import {MerchantPageHeader} from "../../../helpers/Display";

const AMOUNT_MIN = 0;


module.exports = withState((setState, self, onMount) => {
  const checkingForUpdates = checkingForUpdatesProvider(setState, (params) => {
    return apiV2GetTransactionDetails(filter({
      order_id: params.orderId,
      payment_id: params.paymentId,
    })).then((res) => {
      setState({
        amount: res.refundable_amount || '0',
        email: res.email || '',
        name: ''
      })
      return res;
    });
  });

  onMount(() => {
    // const account = self.state.account || {};
    // setState({
    //   email: account.username,
    //   name: account.company
    // })
  })

  const changeProvider = changeProviderProvider(setState);
  const handleChangeEmail = changeProvider('email');
  const handleChangeName = changeProvider('name');
  const handleChangeAmount = changeProvider('amount', 0, numberHandle);

  return (state, props) => {
    const params = props.params || {};

    checkingForUpdates(params);

    const orderId = params.orderId;

    const clicked = state.clicked || false;

    const data = state.data || {};

    const amountCode = data.sc_code ? data.sc_code : data.fiat_code;
    const total = data.refundable_amount || '0';
    const formatedTotal = formatNumCurrency(total);
    const totalNumber = parseFloat(total);
    const disabledRefund = !totalNumber;

    const amountOfFinal = state.amount || '';

    const amountOfFinalNumber = amountOfFinal ? parseFloat(amountOfFinal) : 0;
    const email = state.email || '';
    const name = state.name || '';

    const _name = trim(name);
    const _email = trim(email);

    const invalidAmountOfFinalEmpty = !amountOfFinal;
    const invalidAmountOfFinalMin = AMOUNT_MIN > amountOfFinalNumber || !amountOfFinalNumber;
    const invalidAmountOfFinalMax = amountOfFinalNumber > totalNumber;
    const invalidAmountOfFinal = invalidAmountOfFinalEmpty
      || invalidAmountOfFinalMin
      || invalidAmountOfFinalMax;

    const invalidName = !_name;
    const invalidEmail = !isEmail(_email);

    const disabled = invalidAmountOfFinal
      || invalidName
      || invalidEmail;

    const isTotalAmount = Number(amountOfFinal) === Number(total);

    return (
      <WrapperWithLoading
        className={'wmin270 wmax1000 ' + (props.className || '')}
        loading={state.loading}
      >
        <MerchantPageHeader
          title="Refund"
          backFN={backLocation}
        />
        <div className="mt35 cfx mh-28 (w1/2|ph28|w@m|lt)>1">
          <div>
            <div className="f12">
              Please choose how much of this payment you would like to refund.
              If partial, you will have to enter the amount manually
            </div>
            <div className="mt30 mb40 f12 fw7">
              <div className="dF">
                Order ID:&nbsp;
                <Tooltip className="fhaS*2"
                  title={orderId}>{toEllipsisMiddle(orderId, 20)}</Tooltip>
              </div>
              <div className="mt10">
                Total refundable amount: {formatedTotal} {amountCode}
              </div>
              <div className="mt10">
                Amount after refund: {formatNumCurrency(total - amountOfFinal)} {amountCode}
              </div>
            </div>
          </div>
          <div>
            <div className="rlv">
              <div className={
                `abs st50% sl0 x0y-50% f12 fw7 lh18 dn-i o100 o50.isTotal`
                + (isTotalAmount ? ' isTotal' : '')
              }>
                Partial refund
              </div>
              <div className="pl90">
                <Switch
                  label="Full refund"
                  className={
                    `mr15 (dn-i|o50)>.SwitchC_Label o100.isTotal>.SwitchC_Label`
                    + (isTotalAmount ? ' isTotal' : '')
                  }
                  checked={isTotalAmount}
                  onChange={() => {
                    const value = isTotalAmount ? '0' : String(total);
                    handleChangeAmount({target: {value}});
                  }}
                  disabled={disabledRefund}
                />
              </div>
            </div>
            <div className="dF mt35">
              {/*<Switch*/}
              {/*  label="Partial refund"*/}
              {/*  className="mr15"*/}
              {/*  checked={!fullRefund}*/}
              {/*  onChange={toggleRefund}*/}
              {/*  disabled={disabledRefund}*/}
              {/*/>*/}
              <TextField
                className="rlv sb27"
                label="Refund amount"
                disabled={disabledRefund}
                value={amountOfFinal}
                onChange={(e) => {
                  const targetValue = e.target.value;
                  const value = Number(targetValue) > Number(total) ? total : targetValue;
                  handleChangeAmount({target: {value}})
                }}
                error={clicked && invalidAmountOfFinal}
                helperText={(<div className="wmin400">
                  {
                    invalidAmountOfFinalEmpty
                      ? `Obligatory field`
                      : (
                        invalidAmountOfFinalMax
                          ? `The amount must not exceed ${formatedTotal}`
                          : `The amount must be greater than ${formatNumCurrency(AMOUNT_MIN)}`
                      )
                  }
                </div>)}
              />
            </div>
          </div>
        </div>

        <div className="mt50 h1 w bgDADCE1"/>

        <div className="mt35 cfx mh-28 (w1/2|ph28|w@m|lt)>1">
          <TextField
            className="mt30"
            label="Customer email"
            value={email}
            onChange={handleChangeEmail}
            error={clicked && invalidEmail}
            helperText={_email ? 'Invalid email' : 'Obligatory field'}
            disabled={disabledRefund}
            maxLength={250}
          />
          <TextField
            className="mt30"
            label="Customer name"
            value={name}
            onChange={handleChangeName}
            error={clicked && invalidName}
            helperText="Obligatory field"
            disabled={disabledRefund}
            maxLength={250}
          />
        </div>
        <div className="mt7 cfx mh-30 (lt|ph30)>1">
          <div>
            <Button
              className="mt37"
              disabled={disabledRefund || clicked && disabled}
              onClick={() => {
                if (disabled) {
                  setState({
                    clicked: true,
                  });
                  return;
                }
                setState({
                  loading: true,
                });
                apiV2TransactionRefund({
                  idempotence_key: getIdempotenceKey(),
                  payment_id: data.payment_id || params.paymentId,
                  fiat_amount: amountOfFinal,
                  email: _email,
                  name: _name,
                }).finally((error) => {
                  error || (
                    backLocation(),
                    openPopupInfo([
                      'Refund request sent successfully',
                      `A ${isTotalAmount ? 'full' : 'partial'} refund request
for ${formatNumCurrency(amountOfFinal)} ${amountCode}<br/>
to ${_email} has been initiated`,
                    ])
                  );
                  setState({
                    loading: false,
                  });
                });
              }}
            >Request refund</Button>
          </div>
        </div>
      </WrapperWithLoading>
    );
  };
}, {
  account: account$
});
